module.exports = __webpack_public_path__ + "static/media/cross.d7d55620.png";